export default __webpack_public_path__ + "static/etp-4da7e8faa0232ec35e94b82be0de6de8.png";